import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";

const uploadfilesSlice = createSlice({
  name: "attachments",
  initialState: {
    data: [],
    loading: false,
    status: false,
    error: null,
  },
  reducers: {
    uploadfilesStart: (state) => {
      state.status = true;
      state.loading = true;
    },
    uploadfilesSuccess: (state, action) => {
      state.status = true;
      state.loading = false;
      state.data = action.payload;
      // let newData = [];

      // // Check if action.payload is an array
      // if (Array.isArray(action.payload)) {
      //   // Flatten all the `urls` arrays into one single array
      //   newData = action.payload.reduce((acc, curr) => {
      //     return acc.concat(curr.urls); // Concatenate the `urls` array of each object
      //   }, []);
      // } else if (action.payload && typeof action.payload === "object") {
      //   // If it's a single object, wrap it in an array and flatten it
      //   newData = [action.payload].reduce((acc, curr) => {
      //     return acc.concat(curr.urls); // Concatenate the `urls` array of the object
      //   }, []);
      // }
    },
    uploadfilesFailure: (state, action) => {
      state.status = false;
      state.loading = false;
      state.error = action.payload;
    },
    Imagesuploaded: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    ClearImages: (state) => {
      state.data = null;
      state.loading = false;
      state.status = false;
      state.error = null;
    },
  },
});

export const {
  uploadfilesStart,
  uploadfilesSuccess,
  uploadfilesFailure,
  ClearImages,
  Imagesuploaded,
} = uploadfilesSlice.actions;

export const AttachmentFiles = (data, prev) => async (dispatch) => {
  try {
    // const formData = new FormData();
    // for (const file of data) {
    //   formData.append("file", file);
    // }
    dispatch(uploadfilesStart());
    const response = await axios.post(`/private/backend/multiple`, data);
    if (response?.status === 201) {
      const returnedTarget = prev?.length
        ? prev.concat(response?.data)
        : response?.data;
      dispatch(uploadfilesSuccess(returnedTarget));
    }
  } catch (err) {
    const errorMessage =
      err?.response?.data?.message || err.message || "Something went wrong!";
    toast.error(errorMessage);
    dispatch(uploadfilesFailure(errorMessage));
  }
};

export default uploadfilesSlice.reducer;
